import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import ResponsiveGatsbyImage from '../ResponsiveGatsbyImage'

/* カードの表示幅。u-container（幅 85%・最大 960px。768px 以下は 90%）を 3 列（1024px 以下は 2 列、768px 以下は 1 列）・隙間 40px で割った値。
   指定しないとクエリの width: 864 から作られる sizes になり、表示幅の約 3 倍の画像が選ばれる（#827） */
const CARD_IMAGE_SIZES = '(max-width: 768px) 90vw, (max-width: 1024px) calc(42.5vw - 20px), 294px'

/** @param {{ data?: any, loading?: 'eager' | 'lazy' }} props */
const SeminarCard = ({ data, loading = 'lazy' }) => {
  const [now, setNow] = useState(/** @type {Date | null} */ (null))
  const [isClient, setIsClient] = useState(false)
  const [seminarStart, setSeminarStart] = useState('')
  const [seminarEnd, setSeminarEnd] = useState('')

  useEffect(() => {
    /* oxlint-disable-next-line react/set-state-in-effect -- ビルド時ではなくブラウザで開いた時点の時刻で受付終了を判定し、閲覧者のタイムゾーンで日時を表示するため */
    setIsClient(true)
    setNow(new Date())

    const formattedStartDate = data?.seminarStart ? new Date(data.seminarStart) : null
    const formattedEndDate = data?.seminarEnd ? new Date(data.seminarEnd) : null

    const returnStartDate = (date) => {
      if (!date || isNaN(date.getTime())) return ''
      const weekdays = ['日', '月', '火', '水', '木', '金', '土']
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const monthStr = String(month).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      const weekday = weekdays[date.getDay()]
      return `${year}年${monthStr}月${day}日(${weekday})${hour}:${minute}`
    }

    const returnEndDate = (date) => {
      if (!date || isNaN(date.getTime())) return ''
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      return `${hour}:${minute}`
    }

    setSeminarStart(returnStartDate(formattedStartDate))
    setSeminarEnd(returnEndDate(formattedEndDate))
  }, [data?.seminarStart, data?.seminarEnd])

  const formattedStartDate = isClient && data?.seminarStart ? new Date(data.seminarStart) : null
  const pcImageData = data?.thumbnail?.gatsbyImageData
  const spImageData = data?.thumbnailSp?.gatsbyImageData
  const isPast = isClient && now && formattedStartDate && now > formattedStartDate

  return (
    <article className="seminarCard">
      {isPast ? <span className="seminarCard__tag seminarCard__tag--past">受付終了</span> : <span className="seminarCard__tag">受付中</span>}
      <span className="seminarCard__date">{isClient ? `${seminarStart} - ${seminarEnd}` : ''}</span>
      <Link className="seminarCard__link" to={`/aim/seminar/${data?.slug}`}>
        {pcImageData && (
          <ResponsiveGatsbyImage pcImageData={pcImageData} spImageData={spImageData} alt={data?.title} className="seminarCard__image" loading={loading} sizes={CARD_IMAGE_SIZES} />
        )}
        <div className="seminarCard__contents">
          <h2 className="seminarCard__heading2">{data?.title}</h2>
          <div className="seminarCard__more">
            セミナーの詳細を見る
            <FontAwesomeIcon className="seminarCard__moreIcon" icon={faAngleRight} />
          </div>
        </div>
      </Link>
    </article>
  )
}

export default SeminarCard
